import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { toast } from 'react-toastify';
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from 'firebase/firestore/lite';
import { updateProfile } from 'firebase/auth';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';

import apiConfig from '../../config/apiConfig';
import {
  updateUserDataAction,
  updateUserFollowingArtistsAction,
  showUsernameDialog,
  setUserAuthTOken,
} from '../../store/actions/actionsMain';
import { createwallet, getwalletDetails } from '../../services/common-query';
import { checkUsername } from '../../helpers/regex';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { firebaseAuthFunc } from '../../config/firebaseAuth';
import { firebaseFunctions } from '../../config/firebaseFunctions';
// var googleProvider = new GoogleAuthProvider();

// var twitterprovider = new TwitterAuthProvider();
// var facebookprovider = new FacebookAuthProvider();

export default function RegisterComponent() {
  const router = useRouter();
  const { page } = router.query;
  const dispatch = useDispatch();

  const [loadingSignup, setloadingSignup] = useState(false);
  const [disableAnchors, setdisableAnchors] = useState(false);
  const [emailField, setemailField] = useState('');
  const [passwordField, setpasswordField] = useState('');
  const [usernameField, setusernameField] = useState('');
  // const [userlastnameField, setuserlastnameField] = useState("");

  const [isAgree, setIsAgree] = useState(false);
  const [isAgreeTerms, setIsAgreeTerms] = useState(false);

  React.useEffect(() => {
    if (router?.query?.isAgreed) setIsAgree(Boolean(router.query.isAgreed));
  }, []);
  const onPolicy = (event) => {
    setIsAgree(event.target.checked);
  };

  React.useEffect(() => {
    if (router?.query?.isAgreeTerms)
      setIsAgreeTerms(Boolean(router.query.isAgreeTerms));
  }, []);

  const onTerms = (event) => {
    setIsAgreeTerms(event.target.checked);
  };

  const emailSignup = async (e) => {
    e.preventDefault();
    setloadingSignup(true);
    setdisableAnchors(true);

    const { error, errorMessage } = checkUsername(usernameField, 'Username');

    if (error) {
      toast.error(errorMessage, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setloadingSignup(false);
      setdisableAnchors(false);
      return;
    }

    //checking for duplicates

    const q = query(
      collection(firebaseFireStore, 'MusicArtUsernames'),
      where('userName', '==', usernameField.toLowerCase()),
    );

    let snap = await getDocs(q);

    if (!snap.empty) {
      toast.error('Username already exists.', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setloadingSignup(false);
      setdisableAnchors(false);
      return;
    }
    if (!isAgree) {
      toast.error('Please agree to the Privacy Policy.', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setloadingSignup(false);
      setdisableAnchors(false);

      return;
    }
    if (!isAgreeTerms) {
      toast.error('Please agree to the Terms and Conditions.', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setloadingSignup(false);
      setdisableAnchors(false);

      return;
    }

    createUserWithEmailAndPassword(firebaseAuthFunc, emailField, passwordField)
      .then(async (userer) => {
        //sending verfication email

        let resendEmailAPI = httpsCallable(
          firebaseFunctions,
          'verificationEmailLink',
        );
        resendEmailAPI();
        console.log('run 1');

        var user = firebaseAuthFunc.currentUser;

        // setting username
        setDoc(doc(firebaseFireStore, 'MusicArtUsernames', user.uid), {
          userName: usernameField.toLowerCase(),
          userNameDisplay: usernameField,
        });

        let userLocal = {
          ...userer.user,
          displayName: usernameField,
        };

        await updateProfile(user, {
          displayName: userLocal.displayName,
        });

        if (userLocal) {
          !userLocal.displayName && dispatch(showUsernameDialog(true));
          dispatch(updateUserDataAction(userLocal));
          dispatch(updateUserFollowingArtistsAction([]));
        }

        userer &&
          // <------ Check this line
          user.getIdToken().then((token) => {
            apiConfig.defaults.headers.common['authToken'] = token;
            dispatch(setUserAuthTOken(token));
            console.log('userLocal', userLocal);
            createwallet('default', dispatch, userLocal.uid);
          });

        console.log('run 2');

        if (window && window.gtag) {
          console.log('calling ga event');
          window.gtag('event', 'Successful Registration', {
            event_category: 'Registration and Login',
            nonInteraction: false,
          });
        }

        toast.success(
          'Thank you for registering with us. An email has been sent to you for verification.',
          {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          },
        );
        setloadingSignup(false);
        setTimeout(() => {
          // uid.nftId ? router.push(`/manageNFT/${uid.nftId}`) : router.push('/');
          page ? router.push(`/${page}`) : router.push('/');
          setdisableAnchors(false);
        }, 300);
      })
      .catch((error) => {
        const { message, code } = error;
        let errorMessage = '';
        switch (code) {
          case 'auth/invalid-email': {
            errorMessage = 'Invalid email.';
            break;
          }
          case 'auth/email-already-in-use': {
            errorMessage =
              'This email address is not available. Choose a different address.';
            break;
          }
          case 'auth/invalid-password':
          case 'auth/weak-password': {
            errorMessage =
              'The password is too weak. Please choose a strong password with at least 6 characters.';
            break;
          }
          default: {
            errorMessage = message;
            break;
          }
        }
        toast.error(errorMessage, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloadingSignup(false);
        setdisableAnchors(false);
      });
  };

  // const signInWithfacebook = () => {

  //     signInWithPopup(firebaseAuthFunc,facebookprovider)
  //     .then(function (result) {
  //       if (result.user) {
  //         !result.user.displayName && dispatch(showUsernameDialog(true));
  //         dispatch(updateUserDataAction(result.user));
  //         result.user &&
  //           result.user.getIdToken().then((idToken) => {
  //             // console.log("usertoken", idToken);
  //             apiConfig.defaults.headers.common["authToken"] = idToken;
  //             dispatch(setUserAuthTOken(idToken));

  //             if (result.additionalUserInfo.isNewUser) {
  //               createwallet("default", dispatch);
  //             } else {
  //               getwalletDetails(
  //                 "00000000-0000-0000-0000-000000000000",
  //                 dispatch
  //               );
  //             }
  //             // It shows the Firebase token now
  //           });
  //         getFollowingSellers(result.user.uid);
  //       }
  //       toast.success("You have successfully signed in!", {
  //         position: "bottom-left",
  //         autoClose: 10000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //       });
  //       setTimeout(() => {
  //         router.push("/");
  //       }, 300);
  //     })
  //     .catch(function (error) {
  //       var errorMessage = error.message;
  //       toast.error(errorMessage, {
  //         position: "bottom-left",
  //         autoClose: 10000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //       });
  //     });
  // };
  // const signInWithGoogle = () => {

  //   signInWithPopup(firebaseAuthFunc,googleProvider)
  //     .then(function (result) {
  //       if (result.user) {
  //         !result.user.displayName && dispatch(showUsernameDialog(true));
  //         dispatch(updateUserDataAction(result.user));
  //         getFollowingSellers(result.user.uid);
  //         result.user &&
  //           result.user.getIdToken().then((idToken) => {
  //             // <------ Check this line
  //             // console.log("usertoken", idToken);
  //             apiConfig.defaults.headers.common["authToken"] = idToken;
  //             dispatch(setUserAuthTOken(idToken));
  //             if (result.additionalUserInfo.isNewUser) {
  //               createwallet("default", dispatch);
  //             } else {
  //               getwalletDetails(
  //                 "00000000-0000-0000-0000-000000000000",
  //                 dispatch
  //               );
  //             }
  //           });
  //       }
  //       toast.success("You have successfully signed in!", {
  //         position: "bottom-left",
  //         autoClose: 10000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //       });
  //       setTimeout(() => {
  //         router.push("/");
  //       }, 300);
  //     })
  //     .catch(function (error) {
  //       var errorMessage = error.message;
  //       toast.error(errorMessage, {
  //         position: "bottom-left",
  //         autoClose: 10000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //       });
  //     });
  // };

  // const signInWithTwitter = () => {

  //   signInWithPopup(firebaseAuthFunc,twitterprovider)
  //     .then(function (result) {
  //       if (result.user) {
  //         !result.user.displayName && dispatch(showUsernameDialog(true));
  //         dispatch(updateUserDataAction(result.user));
  //         getFollowingSellers(result.user.uid);
  //         result.user &&
  //           result.user.getIdToken().then((idToken) => {
  //             // <------ Check this line
  //             // console.log("usertoken", idToken);
  //             apiConfig.defaults.headers.common["authToken"] = idToken;
  //             dispatch(setUserAuthTOken(idToken));
  //             if (result.additionalUserInfo.isNewUser) {
  //               createwallet("default", dispatch);
  //             } else {
  //               getwalletDetails(
  //                 "00000000-0000-0000-0000-000000000000",
  //                 dispatch
  //               );
  //             }
  //             // It shows the Firebase token now
  //           });
  //       }
  //       toast.success("You have successfully signed in!", {
  //         position: "bottom-left",
  //         autoClose: 10000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //       });
  //       setTimeout(() => {
  //         router.push("/");
  //       }, 300);
  //     })
  //     .catch(function (error) {
  //       var errorMessage = error.message;
  //       toast.error(errorMessage, {
  //         position: "bottom-left",
  //         autoClose: 10000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //       });
  //     });
  // };

  return (
    <>
      <main className="main center_container">
        <div className="container">
          <div className="row row--grid">
            <div className="w-full pt-2">
              <ul className="breadcrumb">
                <li className="breadcrumb__item yellow__back">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb__item--active yellow__back--active">
                  Sign Up
                </li>
              </ul>
            </div>
          </div>

          <div className="w-full">
            <div className="sign">
              <div className="sign__content">
                <form
                  id="register-form"
                  onSubmit={emailSignup}
                  className="sign__form"
                >
                  <a href="/" className="sign__logo">
                    MusicArt
                  </a>
                  <div className="sign__group" style={{ marginBottom: 10 }}>
                    <input
                      type="text"
                      className="sign__input"
                      placeholder="Username"
                      required
                      value={usernameField}
                      onChange={(e) => {
                        setusernameField(e.target.value);
                      }}
                    />
                    {usernameField && usernameField.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          setusernameField('');
                        }}
                        className="close_icon"
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                  </div>
                  <span className="helper_text">
                    Choose a username with 6–30 characters. It can contain
                    letters (a-z, A-Z), numbers (0-9), and periods (.).
                  </span>

                  {/* <div className="sign__group">
                    <input
                      type="text"
                      className="sign__input"
                      placeholder="Last name"
                      required
                      value={userlastnameField}
                      onChange={(e) => {
                        setuserlastnameField(e.target.value);
                      }}
                    />
                  </div> */}

                  <div className="sign__group">
                    <input
                      type="email"
                      className="sign__input"
                      placeholder="Email"
                      required
                      value={emailField}
                      onChange={(e) => {
                        setemailField(e.target.value);
                      }}
                    />
                    {emailField && emailField.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          setemailField('');
                        }}
                        className="close_icon"
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                  </div>

                  <div className="sign__group">
                    <input
                      type="password"
                      className="sign__input"
                      placeholder="Password"
                      required
                      value={passwordField}
                      onChange={(e) => {
                        setpasswordField(e.target.value);
                      }}
                    />
                    {passwordField && passwordField.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          setpasswordField('');
                        }}
                        className="close_icon"
                      >
                        <HighlightOffIcon />
                      </button>
                    )}
                  </div>

                  <div className="sign__group sign__group--checkbox sign_up_label_wrapper">
                    <input
                      id="remember"
                      name="remember"
                      type="checkbox"
                      onChange={onPolicy}
                      checked={isAgree}
                    />
                    <label htmlFor="remember">
                      I have read and agree to the&nbsp;
                      <a
                        disabled={disableAnchors}
                        style={{
                          pointerEvents: disableAnchors ? 'none' : 'auto',
                        }}
                        href="/privacy-policy"
                        target="_blank"
                      >
                        Privacy Policy.
                      </a>
                    </label>
                  </div>
                  <div className="sign__group sign__group--checkbox sign_up_label_wrapper">
                    <input
                      id="rememberme"
                      name="rememberme"
                      type="checkbox"
                      onChange={onTerms}
                      checked={isAgreeTerms}
                    />
                    <label htmlFor="rememberme">
                      I have read and agree to the&nbsp;
                      <a
                        disabled={disableAnchors}
                        style={{
                          pointerEvents: disableAnchors ? 'none' : 'auto',
                        }}
                        href="/terms-of-service"
                        target="_blank"
                      >
                        Terms of Service.
                      </a>
                    </label>
                  </div>
                  <div className="w-full">
                    <button
                      type="submit"
                      className={
                        loadingSignup ? `sign__btn disable_btn` : `sign__btn`
                      }
                      disabled={loadingSignup ? true : false}
                    >
                      {loadingSignup ? (
                        <div className="flex justify-center	w-full my-6 mx-6 follow-btn-loader">
                          <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                        </div>
                      ) : (
                        <>Sign Up</>
                      )}
                    </button>
                  </div>

                  {/* <span className="sign__delimiter">or</span>

                  <div className="sign__social">
                     <a className="fb" onClick={signInWithfacebook}>
                      <svg
                        viewBox="0 0 9 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M5.56341 16.8197V8.65888H7.81615L8.11468 5.84663H5.56341L5.56724 4.43907C5.56724 3.70559 5.63693 3.31257 6.69042 3.31257H8.09873V0.5H5.84568C3.1394 0.5 2.18686 1.86425 2.18686 4.15848V5.84695H0.499939V8.6592H2.18686V16.8197H5.56341Z" />
                      </svg>
                    </a> 
                    <a className="tw" onClick={signInWithTwitter}>
                      <svg
                        viewBox="0 0 16 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M7.55075 3.19219L7.58223 3.71122L7.05762 3.64767C5.14804 3.40404 3.47978 2.57782 2.06334 1.1902L1.37085 0.501686L1.19248 1.01013C0.814766 2.14353 1.05609 3.34048 1.843 4.14552C2.26269 4.5904 2.16826 4.65396 1.4443 4.38914C1.19248 4.3044 0.972149 4.24085 0.951164 4.27263C0.877719 4.34677 1.12953 5.31069 1.32888 5.69202C1.60168 6.22165 2.15777 6.74068 2.76631 7.04787L3.28043 7.2915L2.67188 7.30209C2.08432 7.30209 2.06334 7.31268 2.12629 7.53512C2.33613 8.22364 3.16502 8.95452 4.08833 9.2723L4.73884 9.49474L4.17227 9.8337C3.33289 10.321 2.34663 10.5964 1.36036 10.6175C0.888211 10.6281 0.5 10.6705 0.5 10.7023C0.5 10.8082 1.78005 11.4014 2.52499 11.6344C4.75983 12.3229 7.41435 12.0264 9.40787 10.8506C10.8243 10.0138 12.2408 8.35075 12.9018 6.74068C13.2585 5.88269 13.6152 4.315 13.6152 3.56293C13.6152 3.07567 13.6467 3.01212 14.2343 2.42953C14.5805 2.09056 14.9058 1.71983 14.9687 1.6139C15.0737 1.41264 15.0632 1.41264 14.5281 1.59272C13.6362 1.91049 13.5103 1.86812 13.951 1.39146C14.2762 1.0525 14.6645 0.438131 14.6645 0.258058C14.6645 0.22628 14.5071 0.279243 14.3287 0.374576C14.1398 0.480501 13.7202 0.639389 13.4054 0.734722L12.8388 0.914795L12.3247 0.565241C12.0414 0.374576 11.6427 0.162725 11.4329 0.0991699C10.8978 -0.0491255 10.0794 -0.0279404 9.59673 0.14154C8.2852 0.618204 7.45632 1.84694 7.55075 3.19219Z" />
                      </svg>
                    </a>
                    <a className="gl" onClick={signInWithGoogle}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="ionicon"
                        viewBox="0 0 512 512"
                      >
                        <path d="M473.16 221.48l-2.26-9.59H262.46v88.22H387c-12.93 61.4-72.93 93.72-121.94 93.72-35.66 0-73.25-15-98.13-39.11a140.08 140.08 0 01-41.8-98.88c0-37.16 16.7-74.33 41-98.78s61-38.13 97.49-38.13c41.79 0 71.74 22.19 82.94 32.31l62.69-62.36C390.86 72.72 340.34 32 261.6 32c-60.75 0-119 23.27-161.58 65.71C58 139.5 36.25 199.93 36.25 256s20.58 113.48 61.3 155.6c43.51 44.92 105.13 68.4 168.58 68.4 57.73 0 112.45-22.62 151.45-63.66 38.34-40.4 58.17-96.3 58.17-154.9 0-24.67-2.48-39.32-2.59-39.96z" />
                      </svg>
                    </a>
                  </div> */}

                  <span className="sign__text">
                    Already have an account?{' '}
                    <a
                      disabled={disableAnchors}
                      style={{
                        pointerEvents: disableAnchors ? 'none' : 'auto',
                      }}
                      href="/auth/login"
                    >
                      Sign In
                    </a>
                  </span>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
